<template>
  <div>
    <div class="row" style="height: 60px"></div>
    <div class="row titleRow">
      <div class="col">
        <h2>{{$t('whatLevel.subtitle')+$store.state.form.resultJson.userInfos.firstname+" "+$store.state.form.resultJson.userInfos.lastname}}</h2>
        <h1>{{$t('whatLevel.title')}}</h1>
      </div>
    </div>
    <div class="row listOfButtons">
      <div class="col">
        <button :class="'btn btn-secondary targetButton ' + ((level == 'high') ? 'bg-color' : '')" @click="level='high'">{{$t('whatLevel.high')}}</button>
      </div>
      <div class="col">
        <button :class="'btn btn-secondary targetButton ' + ((level == 'veryHigh') ? 'bg-color' : '')" @click="level='veryHigh'">{{$t('whatLevel.veryHigh')}}</button>
      </div>
      <div class="col">
        <button :class="'btn btn-secondary targetButton ' + ((level == 'highest') ? 'bg-color' : '')" @click="level='highest'">{{$t('whatLevel.highest')}}</button>
      </div>
    </div>
    <div class="row alignRight ">
      <div class="col overFooter">
        <button type="submit" :class="'btn btn-primary alignRight ' + ((level !== '') ? 'bg-color' : '')" @click="saveData()">{{$t('general.next')}}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'what-level',
  data () {
    return {
      level: ''
    };
  },
  updated: function () {
    // Vérifie si les champs obligatoires ont bien été remplis
    this.$store.dispatch('form/FORM_AUTHORIZENEXTSTEP', {layout: 'WhatLevel', isAuthorized: this.level !== '', data: {whatLevel: this.level}});
  },
  methods: {
    saveData: function () {
      if (this.level !== '') {
        this.$store.dispatch('form/FORM_NEXTLAYOUT', {whatLevel: this.level});
      }
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layouts/WhatLevel.vue